module.exports = __webpack_public_path__ + "media/images/communities/logos/ao11-2a76d4ebadee2b9eb5b84e4e99516678.png";